import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { isMobile } from 'react-device-detect'
import Autosuggest from 'react-autosuggest'
import Fuse from 'fuse.js'

import fuseGlobalOpts from '../../../../utils/fuse-global-options'
import { focusFilterIndustry } from '../../../../actions'

import './autosuggest.scss'

const getSuggestionValue = suggestion => {
    return suggestion
}

const renderSuggestion = suggestion => {
    return (
        <div>{suggestion}</div>
    )
}

class Autosuggestion extends Component {

    state = {
        value: '',
        suggestions: []
    }

    constructor (props) {
        super(props)

        this.inputRef = React.createRef()
    }

    componentDidMount () {

        this.inputRef.current.input.addEventListener('keyup', this.onKeyUp, false)
        this.inputRef.current.input.addEventListener('focus', this.onFocus, false)
        this.inputRef.current.input.addEventListener('blur', this.onBlur, false)

        // this.inputRef.current.input.value = this.props.defaultValue
        this.setState({ value: this.props.defaultValue })
    }

    componentWillUnmount () {
        this.inputRef.current.input.removeEventListener('keyup', this.onKeyUp, false)
        this.inputRef.current.input.removeEventListener('focus', this.onFocus, false)
        this.inputRef.current.input.removeEventListener('blur', this.onBlur, false)
    }

    onKeyUp = (e) => {
        if (e.keyCode === 13) { // Enter
            const { location: currentLocation } = this.props
            this.props.history.push(`/${this.state.value.toLowerCase()}/${currentLocation}/1`)
        }
    }

    onFocus = () => {
        this.props.dispatch(focusFilterIndustry(true))
    }

    onBlur = () => {
        const { location: currentLocation } = this.props
        const company = this.state.value === '' ? 'all' : this.state.value
        this.props.history.push(`/${company}/${currentLocation}/1`)
        this.props.dispatch(focusFilterIndustry(false))
    }

    onChange = (event, { newValue }) => {
        this.setState({ value: newValue })
        if (newValue.length === 0) {
            const { location: currentLocation } = this.props
            this.props.history.push(`/all/${currentLocation}/1`)
        }
    }

    onSuggestionsFetchRequested = ({ value }) => {
        const { results, location } = this.props

        const inputValue = value.trim().toLowerCase()
        const inputLength = inputValue.length
        
        let suggestions = inputLength === 0 ? [] : this.props.suggestions.filter(suggestion => {
            return suggestion.toLowerCase().slice(0, inputLength) === inputValue
        })

        let transformedResults

        if (location === 'anywhere') {
            transformedResults = results
        } else {
            const fuseOpts = Object.assign({}, fuseGlobalOpts, {
                keys: [
                    'info.city',
                    'info.country'
                ]
            })
            const fuse = new Fuse(results, fuseOpts)
            transformedResults = fuse.search(location)
        }

        suggestions = suggestions.filter(suggestion => {
            return transformedResults.find(partner => {
                return partner.name             === suggestion ||
                       partner.info.category    === suggestion ||
                       partner.info.services[0] === suggestion ||
                       partner.info.services[1] === suggestion ||
                       partner.info.services[2] === suggestion ||
                       partner.info.services[3] === suggestion
            })
        })

        this.setState({ suggestions })
    }

    onSuggestionsClearRequested = () => {
        this.setState({ suggestions: [] })
    }

    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        const { location: currentLocation } = this.props
        this.props.history.push(`/${suggestion.toLowerCase()}/${currentLocation}/1`)
    }

    render () {
        const { value, suggestions } = this.state

        const inputProps = {
            placeholder: this.props.placeholder,
            value,
            onChange: this.onChange
        }

        return (
            <Autosuggest
                ref={this.inputRef}
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionSelected={this.onSuggestionSelected}
                focusInputOnSuggestionClick={!isMobile}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps}
            />
        )
    }
}

export default compose(
    withRouter,
    connect((state, props) => {
        return {
            results: state.firebase.data['companies'],
            company: props.match.params.what,
            location: props.match.params.where
        }
    })
)(Autosuggestion)


// WEBPACK FOOTER //
// ./src/components/hero-unit/filter/autosuggest-industry/index.jsx